import React, { ReactNode, ReactEventHandler } from 'react';

import classNames from 'classnames/bind';

import { getLocale } from '@common/utils/locale';
import { Button } from '@components/Button';
import { IconType } from '@components/SvgIcon';

import { locale } from '../../locale';

import styles from './PaginationButton.module.css';

const cn = classNames.bind(styles);

type PaginationButtonProps = {
  disabled: boolean;
  selected?: boolean;
  withMargin?: boolean;
  startIcon?: IconType;
  endIcon?: IconType;
  children: ReactNode;
  onClick?: ReactEventHandler<Element>;
  ariaLabel?: string;
  page?: Nullable<number>;
};

export const PaginationButton = ({
  disabled,
  selected,
  children,
  onClick,
  startIcon,
  endIcon,
  withMargin,
  ariaLabel,
  page,
}: PaginationButtonProps) => {
  const srLabel = !ariaLabel && page ? getLocale(locale.go_to_page, { page }) : ariaLabel;

  return (
    <Button
      className={cn('pagination-button', {
        'pagination-button--disabled': disabled,
        'pagination-button--selected': selected,
        'pagination-button--with-margin': withMargin,
      })}
      onClick={onClick}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
      noHover={disabled}
      title={srLabel}
      aria-label={srLabel}
    >
      {children}
    </Button>
  );
};
